import { PageHead } from '../components/PageHead';
import { PageLinks } from '../components/PageLinks';
import { Details } from '../sections/Details';
import { Schedule } from '../sections/Schedule';
import { pages } from '../content/wedding';

/**
 * Named `DetailsPage` rather than `Details`, which is the section it opens
 * with — the page and its first section want the same word, and only one of
 * them can have it.
 *
 * How the evening runs and the fine print around it. The invitation itself
 * stayed on the landing page — a guest should not have to open a page to be
 * invited — so what is left here is everything they would come looking for
 * afterwards — the fine print first, because what to wear and how to reply
 * are what a guest opens this page for, and the order of the day is what they
 * come back to nearer the time.
 */
export function DetailsPage() {
  return (
    <main class="page" id="top">
      <PageHead {...pages.details} />
      <Details />
      <Schedule />
      <PageLinks />
    </main>
  );
}
